import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { UserService } from 'shared/services/User/user.service';
import { ZendeskWebwidgetService } from 'ng-zendesk-webwidget';

@Component({
  selector: 'app-sub-footer',
  templateUrl: './sub-footer.component.html',
  styleUrls: ['./sub-footer.component.css']
})
export class SubFooterComponent implements OnInit {

  constructor(private us: UserService, private zen: ZendeskWebwidgetService) {}

  ngOnInit() {
  }


  faq(){
    this.zen.activate();
  }

  requestCall(){
    Swal.fire({
      imageUrl: 'assets/images/support.png',
      imageWidth: 100,
      imageAlt: 'Custom image',
      title: "Let us help you!",
      text: "Request a call from your dedicated Ticket Agent by entering your phone number below.",
      input: 'text',
      inputPlaceholder: "Phone Number",
      inputAttributes: {
        autocapitalize: 'off',
      },
      showCancelButton: true,
      confirmButtonText: 'Request a call',
      showLoaderOnConfirm: true,
      preConfirm: (phoneNumber) => {
        let a = (Number.isInteger(Number(phoneNumber)));
        if(a == true){
          this.us.requestGroupInfo("GENERAL", phoneNumber).then(res => {
            Swal.fire({
              title: `Thanks! We'll be in touch with you shortly. `,
              type: "success"
            })
            return res;
          }).catch(err => {
            Swal.fire({
              title: `Hmm. Something went wrong. Try again later. `,
              type: "error"
            })
          })
        } else {
          return Swal.fire({
            type: 'warning',
            title: 'Foul!'
          })
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/sub-footer/sub-footer.component.ts